// ============================================================================
// exportar/version.js — la versión que viaja DENTRO de cada archivo generado
// ----------------------------------------------------------------------------
// ⚠️ Mantener sincronizada con `version` de exportar/package.json. Es un
// archivo aparte (y no un import del package.json) para no depender de los
// atributos de importación de JSON, que Node y Vite tratan distinto.
// ============================================================================
export const VERSION_EXPORTADOR = '0.1.0';
